import React, { useEffect, useState } from 'react';
import { Snackbar, Alert, Button } from '@mui/material';

const PLATFORM = 'web_admin';
const BUILD_ID = process.env.REACT_APP_BUILD_ID || 'dev';
const APP_VERSION = process.env.REACT_APP_VERSION || '0.0.0';
const CHECK_INTERVAL_MS = 5 * 60 * 1000;

async function fetchConfig() {
  const params = new URLSearchParams({ platform: PLATFORM, currentVersion: APP_VERSION });
  const res = await fetch(`/api/app-config/version?${params.toString()}`, {
    headers: { 'X-App-Version': APP_VERSION, 'X-Platform': PLATFORM },
  });
  if (!res.ok) throw new Error(`status ${res.status}`);
  return res.json();
}

/**
 * Polls the backend for the latest web_build_id and shows a non-blocking
 * "new version available" banner when it changes. CI bumps web_build_id
 * after each deploy, so this catches users sitting on stale tabs.
 */
const WebVersionGate = () => {
  const [needsRefresh, setNeedsRefresh] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const cfg = await fetchConfig();
        if (cancelled) return;
        if (cfg.webBuildId && cfg.webBuildId !== BUILD_ID) {
          setNeedsRefresh(true);
        }
      } catch (_) {
        // Silent — we don't want to nag the user about transient network issues.
      }
    };

    check();
    const id = setInterval(check, CHECK_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return (
    <Snackbar
      open={needsRefresh}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity="info"
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => window.location.reload()}
          >
            Refresh
          </Button>
        }
      >
        A new version is available.
      </Alert>
    </Snackbar>
  );
};

export default WebVersionGate;
